export const openLinkInNewTab = (url: string) => {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.rel = 'noopener noreferrer'; // Security best practice
  link.click();
  link.remove();
};
